import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { BookOpen, ListOrdered, HelpCircle } from 'lucide-react';

const ApplicationProcess = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 bg-primary/10 rounded-lg">
              <ListOrdered className="h-8 w-8 text-primary" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4">
            Application Process
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Step-by-step guide to applying for your residence permit
          </p>
        </div>

        <div className="space-y-8">
          <Card>
            <CardHeader>
              <div className="flex items-center space-x-3">
                <ListOrdered className="h-6 w-6 text-primary" />
                <CardTitle>Application Steps</CardTitle>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <ol className="list-decimal pl-6 space-y-4">
                <li>
                  <strong>Prepare Documents</strong>
                  <p className="text-muted-foreground mt-1">Gather all required documents and get them translated by a sworn translator</p>
                </li>
                <li>
                  <strong>Book an Appointment</strong>
                  <p className="text-muted-foreground mt-1">Schedule an appointment at your local voivodeship office</p>
                </li>
                <li>
                  <strong>Pay the Fee</strong>
                  <p className="text-muted-foreground mt-1">Make the payment for your residence card and keep the proof</p>
                </li>
                <li>
                  <strong>Submit Application</strong>
                  <p className="text-muted-foreground mt-1">Visit the office in person to submit your documents and provide fingerprints</p>
                </li>
                <li>
                  <strong>Receive Confirmation</strong>
                  <p className="text-muted-foreground mt-1">Get your application confirmation and temporary residence stamp</p>
                </li>
                <li>
                  <strong>Wait for Processing</strong>
                  <p className="text-muted-foreground mt-1">Track your application status while it's being processed</p>
                </li>
                <li>
                  <strong>Collect Card</strong>
                  <p className="text-muted-foreground mt-1">Pick up your residence card when notified</p>
                </li>
              </ol>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <div className="flex items-center space-x-3">
                <HelpCircle className="h-6 w-6 text-yellow-500" />
                <CardTitle>Important Tips</CardTitle>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <ul className="list-disc pl-6 space-y-2">
                <li>Apply at least 45 days before your current visa/stay expires</li>
                <li>Double-check all documents before your appointment</li>
                <li>Keep copies of everything you submit</li>
                <li>Make sure your photos meet the requirements</li>
                <li>Be prepared for possible additional document requests</li>
              </ul>
            </CardContent>
          </Card>
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => navigate('/knowledge-base/getting-started')}
            className="text-primary hover:text-primary/80 transition-colors"
          >
            ← Back to Getting Started
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApplicationProcess; 